export default __webpack_public_path__ + "static/media/LAP_TC.55d96e1f.png";